/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

export default function registroActividadesData() {
  // Función para renderizar la empresa
  const Empresa = ({ nombre }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {nombre}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  // PropTypes para Empresa
  Empresa.propTypes = {
    nombre: PropTypes.string.isRequired,
  };

  // Función para renderizar el vendedor
  const Vendedor = ({ nombre }) => (
    <MDBox lineHeight={1} textAlign="left">
      <MDTypography display="block" variant="caption" color="text" fontWeight="medium">
        {nombre}
      </MDTypography>
    </MDBox>
  );

  // PropTypes para Vendedor
  Vendedor.propTypes = {
    nombre: PropTypes.string.isRequired,
  };

  // Función para renderizar el estado
  const Estado = ({ estado }) => (
    <MDBox ml={-1}>
      <MDBadge 
        badgeContent={estado} 
        color={estado === "Convertida" ? "success" : "error"} 
        variant="gradient" 
        size="sm" 
      />
    </MDBox>
  );

  // PropTypes para Estado
  Estado.propTypes = {
    estado: PropTypes.string.isRequired,
  };

  // Función para renderizar tests usados con progreso visual
  const TestsUsados = ({ usados, total }) => {
    const porcentaje = (usados / total) * 100;
    return (
      <MDBox lineHeight={1}>
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {usados}/{total}
        </MDTypography>
        <MDBox
          sx={{
            width: "60px",
            height: "4px",
            backgroundColor: "#f0f0f0",
            borderRadius: "2px",
            mt: 0.5,
            position: "relative"
          }}
        >
          <MDBox
            sx={{
              width: `${porcentaje}%`,
              height: "100%",
              backgroundColor: porcentaje > 70 ? "#ff6b6b" : porcentaje > 50 ? "#feca57" : "#48dbfb",
              borderRadius: "2px",
            }}
          />
        </MDBox>
      </MDBox>
    );
  };

  // PropTypes para TestsUsados
  TestsUsados.propTypes = {
    usados: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  };

  return {
    columns: [
      { Header: "empresas", accessor: "empresa", width: "15%", align: "left" },
      { Header: "fecha inicio trial", accessor: "fecha_inicio", align: "center" },
      { Header: "duración", accessor: "duracion", align: "center" },
      { Header: "test usados en trial", accessor: "tests_usados", align: "center" },
      { Header: "fecha conversión", accessor: "fecha_conversion", align: "center" },
      { Header: "plan contratado", accessor: "plan_contratado", align: "center" },
      { Header: "ticket promedio", accessor: "ticket_promedio", align: "center" },
      { Header: "vendedor", accessor: "vendedor", align: "center" },
      { Header: "factores de éxito", accessor: "factores_exito", align: "center" },
    ],

    rows: [
      {
        empresa: <Empresa nombre="Postobon" />,
        fecha_inicio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            25/03/2025
          </MDTypography>
        ),
        duracion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            20 Días
          </MDTypography>
        ),
        tests_usados: <TestsUsados usados={30} total={50} />,
        fecha_conversion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            25/03/2025
          </MDTypography>
        ),
        plan_contratado: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Avanzado
          </MDTypography>
        ),
        ticket_promedio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            $ 100.000
          </MDTypography>
        ),
        vendedor: <Vendedor nombre="Mónica" />,
        factores_exito: <Estado estado="No convertida" />,
        // Datos para filtrado
        rawData: {
          empresa: "Postobon",
          fecha_inicio: "2025-03-25",
          fecha_conversion: "2025-03-25",
          plan_contratado: "Avanzado",
          estado: "No convertida",
          vendedor: "Mónica"
        }
      },
      {
        empresa: <Empresa nombre="Software Solutions" />,
        fecha_inicio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            20/03/2025
          </MDTypography>
        ),
        duracion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            1 Mes
          </MDTypography>
        ),
        tests_usados: <TestsUsados usados={18} total={50} />,
        fecha_conversion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            20/04/2025
          </MDTypography>
        ),
        plan_contratado: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Avanzado
          </MDTypography>
        ),
        ticket_promedio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            $ 100.000
          </MDTypography>
        ),
        vendedor: <Vendedor nombre="Fernando" />,
        factores_exito: <Estado estado="Convertida" />,
        // Datos para filtrado
        rawData: {
          empresa: "Software Solutions",
          fecha_inicio: "2025-03-20",
          fecha_conversion: "2025-04-20",
          plan_contratado: "Avanzado",
          estado: "Convertida",
          vendedor: "Fernando"
        }
      },
      {
        empresa: <Empresa nombre="Tecnicals Corp" />,
        fecha_inicio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            15/02/2025
          </MDTypography>
        ),
        duracion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            3 Meses
          </MDTypography>
        ),
        tests_usados: <TestsUsados usados={35} total={50} />,
        fecha_conversion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            15/05/2025
          </MDTypography>
        ),
        plan_contratado: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Básico
          </MDTypography>
        ),
        ticket_promedio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            $ 80.000
          </MDTypography>
        ),
        vendedor: <Vendedor nombre="Pedro" />,
        factores_exito: <Estado estado="Convertida" />,
        // Datos para filtrado
        rawData: {
          empresa: "Tecnicals Corp",
          fecha_inicio: "2025-02-15",
          fecha_conversion: "2025-05-15",
          plan_contratado: "Básico",
          estado: "Convertida",
          vendedor: "Pedro"
        }
      },
      {
        empresa: <Empresa nombre="Inversiones M&M" />,
        fecha_inicio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            10/01/2025
          </MDTypography>
        ),
        duracion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            25 Días
          </MDTypography>
        ),
        tests_usados: <TestsUsados usados={40} total={50} />,
        fecha_conversion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            04/02/2025
          </MDTypography>
        ),
        plan_contratado: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Medio
          </MDTypography>
        ),
        ticket_promedio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            $ 85.000
          </MDTypography>
        ),
        vendedor: <Vendedor nombre="Vicente" />,
        factores_exito: <Estado estado="Convertida" />,
        // Datos para filtrado
        rawData: {
          empresa: "Inversiones M&M",
          fecha_inicio: "2025-01-10",
          fecha_conversion: "2025-02-04",
          plan_contratado: "Medio",
          estado: "Convertida",
          vendedor: "Vicente"
        }
      },
      {
        empresa: <Empresa nombre="TechStart Colombia" />,
        fecha_inicio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            15/03/2025
          </MDTypography>
        ),
        duracion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            15 Días
          </MDTypography>
        ),
        tests_usados: <TestsUsados usados={45} total={50} />,
        fecha_conversion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            30/03/2025
          </MDTypography>
        ),
        plan_contratado: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Básico
          </MDTypography>
        ),
        ticket_promedio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            $ 50.000
          </MDTypography>
        ),
        vendedor: <Vendedor nombre="Ana" />,
        factores_exito: <Estado estado="Convertida" />,
        // Datos para filtrado
        rawData: {
          empresa: "TechStart Colombia",
          fecha_inicio: "2025-03-15",
          fecha_conversion: "2025-03-30",
          plan_contratado: "Básico",
          estado: "Convertida",
          vendedor: "Ana"
        }
      },
      {
        empresa: <Empresa nombre="Innovate Plus" />,
        fecha_inicio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            10/04/2025
          </MDTypography>
        ),
        duracion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            2 Meses
          </MDTypography>
        ),
        tests_usados: <TestsUsados usados={12} total={50} />,
        fecha_conversion: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            -
          </MDTypography>
        ),
        plan_contratado: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            Medio
          </MDTypography>
        ),
        ticket_promedio: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            $ 75.000
          </MDTypography>
        ),
        vendedor: <Vendedor nombre="Carlos" />,
        factores_exito: <Estado estado="No convertida" />,
        // Datos para filtrado
        rawData: {
          empresa: "Innovate Plus",
          fecha_inicio: "2025-04-10",
          fecha_conversion: null,
          plan_contratado: "Medio",
          estado: "No convertida",
          vendedor: "Carlos"
        }
      },
    ],
  };
} 